import CrudTypesEnum from '../Enums/CrudTypesEnum';

// Wizard item for adding/removing an Apollo ignored client (see
// ApolloIgnoredClientEditWindowDescription). Defaults to the "add" action.
export default class ApolloIgnoredClientEditItem {
  constructor() {
    this.type = CrudTypesEnum.Create;
    this.clientId = '';
  }
}
